import {
  Badge,
  Button,
  Combobox,
  ComboboxContent,
  ComboboxEmpty,
  ComboboxItem,
  ComboboxList,
  ComboboxOption,
  ComboboxSearch,
  ComboboxSelectAll,
  PopoverTrigger,
} from '@e2n/ui/v2';
import { cn } from '@/lib/utils';
import { faXmarkLarge } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function FilterCombobox({
  label,
  options,
  value,
  onValueChange,
  onClear,
  variant,
  searchable = true,
}: {
  label: string;
  options: ComboboxOption[];
  value: string[];
  onValueChange: (value: string[]) => void;
  onClear: () => void;
  variant: 'outline' | 'outline-on-grey';
  searchable?: boolean;
}) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center">
      <Combobox
        multiple
        options={options}
        value={value}
        onValueChange={onValueChange}>
        <PopoverTrigger asChild>
          <Button
            className={cn('gap-2', value.length > 0 && 'rounded-r-none')}
            variant={variant}>
            {label}
            {value.length > 0 && (
              <Badge className="bg-neutrals-v2-300 text-labels-primary">
                {value.length}
              </Badge>
            )}
          </Button>
        </PopoverTrigger>
        <ComboboxContent
          className="md:w-75"
          title={label}
          doneLabel={t('actions.fertig')}>
          {searchable && (
            <ComboboxSearch
              placeholder={t('domain.mitarbeiter.rotationsplan.filter.suchen')}
            />
          )}
          <ComboboxList className={cn(!searchable && 'pt-1')}>
            <ComboboxSelectAll>
              {`${t('actions.alleAuswaehlen')} (${value.length}/${options.length})`}
            </ComboboxSelectAll>
            <ComboboxEmpty
              title={t(
                'domain.mitarbeiter.rotationsplan.filter.keineErgebnisse',
              )}
            />
            {options.map((option) => (
              <ComboboxItem key={option.value} option={option} />
            ))}
          </ComboboxList>
        </ComboboxContent>
      </Combobox>
      {value.length > 0 && (
        <Button
          aria-label={t('actions.resetItem', { returnEmptyString: false })}
          className="-ml-px rounded-l-none"
          variant={variant}
          iconOnly
          onClick={onClear}>
          <FontAwesomeIcon className="size-3" icon={faXmarkLarge} />
        </Button>
      )}
    </div>
  );
}
